<template>
  <div class="reset-password">
    <div class="reset-password-log__wrapper">
      <div class="reset-password-logo">
        <the-logo></the-logo>
      </div>
      <h3 class="reset-password__title">
        {{ $t(resetReason) || $t('common.resetPassword') }}
      </h3>
    </div>
    <div class="reset-password__wrapper">
      <div class="reset-password-input">
        <profet-ai-input :label="$t('common.password')" type="password" v-model="formModel.password"
          focus></profet-ai-input>
      </div>

      <div class="reset-password-input">
        <profet-ai-input :label="showWarnText ? warnMsg.errorText : $t('common.newPassword')" type="password"
          v-model="formModel.newPassword" :isWarning="showWarnText"></profet-ai-input>
      </div>
      <div class="reset-password-input">
        <profet-ai-input :label="showWarnText ? warnMsg.errorText : $t('common.confirmPassword')" type="password"
          v-model="formModel.validPassword" :isWarning="showWarnText"></profet-ai-input>
      </div>
      <p v-show="!warnMsg.responseAlert" class="reset-password__tip">
        - {{ $t('validate.passValid') }}
      </p>
    </div>
    <div v-show="warnMsg.responseAlert" class="reset-password__alert">
      <p>{{ warnMsg.responseAlert }}</p>
    </div>
    <div class="reset-password__submit">
      <button v-show="!loading" class="btn" @click="handleResetPwd">
        {{ $t('common.submit') }}
      </button>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import ProfetAiInput from "./input/ProfetAiInput";
import TheLogo from '@/components/TheLogo'

const AUTH_DOMAIN = window.config.domainHost;

export default {
  components: {
    TheLogo,
    ProfetAiInput,
  }, // End of components
  data() {
    return {
      loading: false,
      showWarnText: false,
      warnMsg: {
        errorText: 'Not Equal',
        responseAlert: '',
      }, // warnMsg
      formModel: {
        password: '',
        newPassword: '',
        validPassword: '',
      }, // formMode
    };
  }, // End of data
  computed: {
    resetReason() {
      return this.$route.query.msg;
    },
    account() {
      return this.$route.params.account;
    }, // account
    isPwdDiff() {
      return this.formModel.newPassword !== this.formModel.validPassword;
    }, // isPwdDiff 
  }, // End of computed
  methods: {
    handleResetPwd() {
      this.warnMsg.responseAlert = '';

      if (this.isPwdDiff) {
        this.showErrText(this.$t('validate.notEqual'));
        return;
      } // if
      else if (!this.validPass(this.formModel.newPassword)) {
        this.showErrText(this.$t('validate.passValid'));
        return;
      } // else if

      this.closeErrText();

      this.sendRequest();

    }, // handleResetPwd()
    sendRequest() {
      axios.post(
        `https://${AUTH_DOMAIN}/login/resetPassword/`,
        {
          "userAccount": this.account,
          "oldPassword": this.formModel.password,
          "newPassword": this.formModel.newPassword,
        },
        {
          withCredentials: true
        }
      )
        .then(res => {
          const data = res.data;

          if (data.code === -1) {
            this.warnMsg.responseAlert = data.msg;
            this.loading = false;
          } // if
          else {
            alert(this.$t("common.changeSucceeded"))
            this.$router.push({ name: 'login' })
          } // else
        })
        .catch(err => {
          this.warnMsg.responseAlert = this.$t('warning.networkErr');
          this.loading = false;
        })
    }, // sendRequest()
    showErrText(text) {
      this.showWarnText = true;
      this.warnMsg.errorText = text;
    }, // showErrText
    closeErrText() {
      this.showWarnText = false;
      this.warnMsg.errorText = '';
    }, // closeErrText
    validPass(password) {
      return /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{10,})/.test(password);
    },
  }, // End of methods
} // End of export
</script>
<style lang="scss" scoped>
.the-logo {
  position: relative;
}

.reset-password-logo {
  padding: 30px 40px 0 30px;
}

.reset-password {
  position: relative;
  width: 500px;
  min-height: 520px;
  background: #edf3fc;
  border-radius: 10px;
  box-shadow: 5px 5px 15px 0px rgba(119, 119, 119, 0.2);

  &__title {
    padding: 20px 0 20px 45px;
    color: #838383;
    font-size: 1.5rem;
    font-weight: 400;
  }

  &__wrapper {
    padding: 0px 30px;

    .profet-ai-input {
      position: relative;
      width: 90%;
      font-size: 0.8em;
    }
  }

  &__tip {
    padding: 0px 10px 30px;
    font-size: 0.8em;
    color: #707070;
    width: 90%;
    line-height: 1.3;
  }

  &__alert {
    border: solid 1px #303030;
    box-sizing: border-box;
    width: calc(100% - 70px);
    text-align: center;
    color: #fc748a;
    font-size: 1.25rem;
    border: 0px;
    border-radius: 5px;
    box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.1);
    padding: 15px;
    margin: 0 auto 15px;
    background: #fff;
    border: 1px solid #fff;
  }
}


.reset-password__submit {
  box-sizing: border-box;
  padding: 0 5%;
  width: 100%;

  .btn {
    color: #fff;
    width: 100%;
    background: #4264ec;
    display: block;
    cursor: pointer;
    border: 0px solid;
    outline: 0px;
    padding: 13px;
    font-size: 1rem;
    border-radius: 5px;

    &:hover,
    &:focus {
      background: #1e43d4;
    }
  }
}

.reset-password__wrapper {
  width: 95%;
}

.reset-password-input {
  margin-bottom: 20px;
}
</style>